(function () {
  if (window.__jojoCampaignRound2) return;
  window.__jojoCampaignRound2 = true;

  var checkoutKey = "jojo-round2-checkout-variant";
  var checkoutPending = false;
  var navigatingToCheckout = false;

  function releaseCheckoutVariant() {
    if (navigatingToCheckout || checkoutPending) return;
    if (!document.querySelector("[data-jojo-round2]")) return;

    var id;
    try {
      id = sessionStorage.getItem(checkoutKey);
    } catch (error) {
      return;
    }
    if (!id) return;

    checkoutPending = true;
    var updates = {};
    updates[id] = 0;
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (response) {
        if (response.ok || response.status === 404 || response.status === 422) {
          try {
            sessionStorage.removeItem(checkoutKey);
          } catch (error) {}
        }
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (cart) {
        if (!cart || cart.item_count == null) return;
        if (window.jQuery) window.jQuery(".CartCount").html(cart.item_count);
        var bubble = document.querySelector(".cart-link__bubble");
        if (!bubble) return;
        if (cart.item_count > 0) bubble.classList.add("cart-link__bubble--visible");
        else bubble.classList.remove("cart-link__bubble--visible");
      })
      .catch(function () {})
      .then(function () {
        checkoutPending = false;
      });
  }

  function enableAddButtons() {
    document.querySelectorAll("[data-round2-add]").forEach(function (button) {
      button.disabled = false;
    });
  }

  window.addEventListener("pageshow", function (event) {
    if (event.persisted) navigatingToCheckout = false;
    enableAddButtons();
    releaseCheckoutVariant();
  });

  function bindFlips(root) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll("[data-round2-flip]").forEach(function (button) {
      if (button.getAttribute("data-round2-ready") === "true") return;
      button.setAttribute("data-round2-ready", "true");

      button.addEventListener("click", function () {
        var flipped = button.classList.toggle("is-flipped");
        var front = button.querySelector('[data-face="front"]');
        var back = button.querySelector('[data-face="back"]');

        button.setAttribute("aria-pressed", flipped ? "true" : "false");
        if (front) front.setAttribute("aria-hidden", flipped ? "true" : "false");
        if (back) back.setAttribute("aria-hidden", flipped ? "false" : "true");
      });
    });
  }

  function initDialog(section) {
    var dialog = section.querySelector("[data-round2-dialog]");
    if (!dialog || dialog.getAttribute("data-round2-ready") === "true") return;
    dialog.setAttribute("data-round2-ready", "true");

    var track = dialog.querySelector("[data-round2-track]");
    var prev = dialog.querySelector("[data-round2-prev]");
    var next = dialog.querySelector("[data-round2-next]");
    var viewport = dialog.querySelector(".jojo-campaign-round2__dialog-viewport");
    var steps = track ? track.children : [];
    var index = 0;
    var timer = null;
    var opener = null;
    var startX = 0;

    function mobile() {
      return window.matchMedia("(max-width: 749px)").matches;
    }

    function reduced() {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }

    function show(nextIndex) {
      var count = steps.length;
      if (!count) return;
      index = (nextIndex + count) % count;
      if (track) {
        track.style.transform = mobile() ? "translateX(" + -index * 100 + "%)" : "";
      }
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === count - 1;
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (!mobile() || reduced() || steps.length < 2) return;
      timer = window.setInterval(function () {
        if (index >= steps.length - 1) {
          stop();
          return;
        }
        show(index + 1);
      }, 4000);
    }

    function open(trigger) {
      opener = trigger || null;
      show(0);
      dialog.hidden = false;
      dialog.classList.add("is-open");
      document.documentElement.classList.add("jojo-campaign-round2-lock");
      var closeButton = dialog.querySelector(".jojo-campaign-round2__dialog-close");
      if (closeButton) closeButton.focus();
      start();
    }

    function close() {
      stop();
      dialog.classList.remove("is-open");
      dialog.hidden = true;
      document.documentElement.classList.remove("jojo-campaign-round2-lock");
      if (opener && opener.focus) opener.focus();
    }

    dialog._round2Close = close;

    section.querySelectorAll("[data-round2-open]").forEach(function (button) {
      if (button.getAttribute("data-round2-ready") === "true") return;
      button.setAttribute("data-round2-ready", "true");
      button.addEventListener("click", function (event) {
        event.preventDefault();
        open(button);
      });
    });

    dialog.querySelectorAll("[data-round2-close]").forEach(function (button) {
      button.addEventListener("click", close);
    });

    if (prev) {
      prev.addEventListener("click", function () {
        if (prev.disabled) return;
        show(index - 1);
        start();
      });
    }

    if (next) {
      next.addEventListener("click", function () {
        if (next.disabled) return;
        show(index + 1);
        start();
      });
    }

    if (viewport) {
      viewport.addEventListener(
        "touchstart",
        function (event) {
          if (!event.changedTouches.length) return;
          startX = event.changedTouches[0].clientX;
        },
        { passive: true }
      );
      viewport.addEventListener(
        "touchend",
        function (event) {
          if (!mobile() || !event.changedTouches.length) return;
          var delta = event.changedTouches[0].clientX - startX;
          if (Math.abs(delta) < 40) return;
          if (delta < 0 && next && !next.disabled) show(index + 1);
          if (delta > 0 && prev && !prev.disabled) show(index - 1);
          start();
        },
        { passive: true }
      );
    }

    dialog.addEventListener("keydown", function (event) {
      if (event.key === "Escape") close();
    });
  }

  function bindAdd(root) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll("[data-round2-add]").forEach(function (button) {
      var form = button.form || button.closest("form");
      if (!form || form.getAttribute("data-round2-ready") === "true") return;
      form.setAttribute("data-round2-ready", "true");

      form.addEventListener("submit", function (event) {
        var id = (button.getAttribute("data-round2-add") || "").trim();
        if (!id || navigatingToCheckout) {
          event.preventDefault();
          return;
        }

        navigatingToCheckout = true;
        try {
          sessionStorage.setItem(checkoutKey, id);
        } catch (error) {}
      });
    });
  }

  function bind(root) {
    bindFlips(root);
    bindAdd(root);
    if (!root || !root.querySelectorAll) return;

    var sections = [];
    if (root.matches && root.matches("[data-jojo-round2]")) {
      sections = [root];
    } else {
      sections = root.querySelectorAll("[data-jojo-round2]");
    }

    Array.prototype.forEach.call(sections, initDialog);
  }

  function boot() {
    bind(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    bind(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    if (!event.target || !event.target.querySelector) return;
    var dialog = event.target.querySelector("[data-round2-dialog]");
    if (dialog && dialog._round2Close) dialog._round2Close();
  });
})();
